import { render, staticRenderFns } from "./currency-amount.vue?vue&type=template&id=23b9259b&scoped=true"
import script from "./currency-amount.ts?vue&type=script&lang=ts&external"
export * from "./currency-amount.ts?vue&type=script&lang=ts&external"
import style0 from "./currency-amount.scss?vue&type=style&index=0&id=23b9259b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b9259b",
  null
  
)

export default component.exports